import { render, staticRenderFns } from "./smartpagetwo.vue?vue&type=template&id=1e433bcc&scoped=true"
import script from "./smartpagetwo.vue?vue&type=script&lang=js"
export * from "./smartpagetwo.vue?vue&type=script&lang=js"
import style0 from "./smartpagetwo.vue?vue&type=style&index=0&id=1e433bcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e433bcc",
  null
  
)

export default component.exports